//#region Imports

import { Component } from '@angular/core';

//#endregion

@Component({
  selector: 'l-loading-bar',
  standalone: true,
  templateUrl: './loading-bar.component.html',
  styleUrl: './loading-bar.component.scss',
})
export class LoadingBarComponent {}
